<template>
  <div>
    <v-row>
      <v-col>
        <v-card flat class="rounded-lg mb-3 textLight--text px-4">
          <v-row align="center" class="text-start mouse-cursor">
            <v-col cols="12" md="3">
              <span class="text-ellipse-4">
                {{ subRole.name }}
              </span>
            </v-col>

            <v-col cols="12" md="8">
              <div v-if="subRole.permissions && subRole.permissions.length">
                <div
                  style="
                    background: rgba(230, 230, 230, 0.5);
                    overflow-y: auto;
                    overflow-x: hidden;
                    min-height: 130px;
                    max-height: 250px;
                  "
                  class="px-4 py-3 rounded-lg d-flex flex-wrap align-content-start"
                >
                  <v-chip
                    v-for="(permission, index) in findPermissions(
                      subRole.permissions
                    )"
                    :key="index"
                    color="#281162"
                    class="me-2 mb-2 rounded-lg py-1 px-3"
                    style="height: auto; min-height: 32px;"
                  >
                    <span
                      class="white--text font-weight-medium"
                      style="font-size: 0.875rem; white-space: normal; word-break: break-word;"
                    >
                      {{ permission }}
                    </span>
                  </v-chip>
                </div>
              </div>

              <div v-else>{{ $t("user.subRoles.noPermissionsAssigned") }}</div>
            </v-col>

            <v-col cols="12" md="1">
              <v-row>
                <template v-if="havePermissionUpdateSubRole">
                  <v-col cols="4" md="12" class="d-flex justify-center">
                    <v-btn
                      height="27"
                      width="27"
                      icon
                      color="primary"
                      @click="$emit('editSubRole', subRole)"
                    >
                      <div class="d-flex flex-column">
                        <v-icon size="20" style="height: 10px">
                          mdi-pencil-outline
                        </v-icon>

                        <v-icon size="20" style="height: 5px">mdi-minus</v-icon>
                      </div>
                    </v-btn>
                  </v-col>
                </template>

                <template
                  v-if="
                    havePermissionUpdateSubRole ||
                    havePermissionEnableDisableSubRole
                  "
                >
                  <v-col cols="4" md="12" class="d-flex justify-center">
                    <v-switch
                      flat
                      dense
                      hide-details
                      inset
                      color="success"
                      v-model="subRole.isActive"
                      :loading="statusUpdateLoading"
                      @change="
                        value => updateOrDelete(value ? 'enable' : 'disable')
                      "
                      class="ma-0"
                    >
                    </v-switch>
                  </v-col>
                </template>

                <template v-if="havePermissionDeleteSubRole">
                  <v-col
                    v-if="
                      !immunableSubRoles.find(role => role === subRole.name)
                    "
                    cols="4"
                    md="12"
                    class="d-flex justify-center"
                  >
                    <v-icon
                      @click="updateOrDelete('delete')"
                      size="20"
                      color="error"
                      >mdi-trash-can-outline</v-icon
                    >
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createOrUpdateSubRole } from "@/app/user-module/methods/createOrUpdateSubRole";
import immunableSubRoles from "../assets/json/immunableSubRoles";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "SubRoleCard",
  props: {
    assignablePermissions: {
      type: Array,
      default: () => [],
    },
    subRole: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      immunableSubRoles,
      permissionsSelected: [],
      statusUpdateLoading: false,
    };
  },
  computed: {
    havePermissionUpdateSubRole() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["UPDATE_SUB_ROLE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableSubRole() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_SUB_ROLE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteSubRole() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_SUB_ROLE"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    findPermissions(existingPermissionsArr) {
      let newArr = this.assignablePermissions.filter(permission => {
        return existingPermissionsArr.find(existingPermission => {
          return permission === existingPermission;
        });
      });
      if (newArr.length) {
        return newArr.map(obj => {
          return obj;
        });
      }
    },
    async updateOrDelete(val) {
      if (val) {
        this.statusUpdateLoading = true;
        if (val === "enable") {
          let response = await createOrUpdateSubRole({
            _id: this.subRole._id,
            isActive: true,
          });
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.subRole.isActive = false;
              this.$emit("updateErr");
            }
          }
        } else if (val === "disable") {
          let response = await createOrUpdateSubRole({
            _id: this.subRole._id,
            isActive: false,
          });
          if (response) {
            this.statusUpdateLoading = false;
            if (response.error) {
              this.subRole.isActive = true;
              this.$emit("updateErr");
            }
          }
        } else if (val === "delete") {
          this.$emit("deleteSubRole", this.subRole._id);
          this.statusUpdateLoading = false;
        }
      }
    },
  },
};
</script>
